import { useMemo } from 'react'
import { useDocument, useLoading } from 'hooks'
import {} from 'domains/Technology/hooks'

const useGetTechnologyInitialValues = (id) => {
  // [DATA_FETCH]
  const [technology, technologyLoading] = useDocument({
    ref: id ? `technologies/${id}` : null
  })

  // [COMPUTED_PROPERTIES]
  const initialValues = useMemo(
    () => ({
      technology
    }),
    [technology]
  )
  const loadings = useMemo(
    () => (id ? [!technology, technologyLoading] : []),
    [id, technology, technologyLoading]
  )

  // [ADDITIONAL_HOOKS]
  const loading = useLoading(loadings)

  return [initialValues, loading]
}

export default useGetTechnologyInitialValues
